import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Animations from './Animation';
import WorkSpace from './WorkSpace';
import AboutPage from './AboutPart';
import GetInTouch from './GetInTouch';

function App() {
  return (
    <div className="App">
      
      <Router>
        <Routes>
          <Route path='/' element={<Animations />} />
          <Route path='workSpace' element={<WorkSpace />}/>
          <Route path='aboutMe' element = {<AboutPage />}/>
          <Route path='getInTouch' element = {<GetInTouch />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
